/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FilesystemFile,
    FilesystemFileFromJSON,
    FilesystemFileFromJSONTyped,
    FilesystemFileToJSON,
    TaskInfo,
    TaskInfoFromJSON,
    TaskInfoFromJSONTyped,
    TaskInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdatedFile
 */
export interface UpdatedFile {
    /**
     * 
     * @type {FilesystemFile}
     * @memberof UpdatedFile
     */
    file: FilesystemFile;
    /**
     * 
     * @type {Array<TaskInfo>}
     * @memberof UpdatedFile
     */
    tasks: Array<TaskInfo>;
}

export function UpdatedFileFromJSON(json: any): UpdatedFile {
    return UpdatedFileFromJSONTyped(json, false);
}

export function UpdatedFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatedFile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'file': FilesystemFileFromJSON(json['file']),
        'tasks': ((json['tasks'] as Array<any>).map(TaskInfoFromJSON)),
    };
}

export function UpdatedFileToJSON(value?: UpdatedFile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file': FilesystemFileToJSON(value.file),
        'tasks': ((value.tasks as Array<any>).map(TaskInfoToJSON)),
    };
}


